import React from 'react';
import classnames from 'classnames';
import readableFileSize from 'filesize';
import FileIcon from '../Icons/File';
import s from './PremiumAsset.scss';
export var PremiumAsset = function (_a) {
    var filename = _a.filename, filesize = _a.filesize, width = _a.width, height = _a.height, muted = _a.muted;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classnames(s['asset-icon'], muted && s['muted']) },
            React.createElement(FileIcon, null)),
        React.createElement("div", { className: classnames(s['asset-info'], muted && s['muted']) },
            React.createElement("div", { className: s['asset-info-top'] },
                React.createElement("div", { className: s['asset-filename'] }, filename),
                width && height && (React.createElement("div", { className: s['asset-resolution'] },
                    width,
                    "x",
                    height,
                    "px"))),
            filesize && (React.createElement("div", { className: s['asset-filesize'] }, readableFileSize(filesize))))));
};
PremiumAsset.displayName = 'PremiumAsset';
export default PremiumAsset;
//# sourceMappingURL=PremiumAsset.js.map